export default {
    'modify-details': 'Modify details',
    'contact-information': 'Contact Information',
    'addresses': 'Addresses',
    'modification-reason': 'Modification reason',
    'confirm-acceptance': 'Confirm acceptance',
    'confirm-rejection': 'Confirm rejection',
    'this-request': 'this request',
    'requests-type': 'Requests type',
    'view-modify-details': 'View modify details',
    'accept-request': 'Accept request',
    'reject-request': 'Reject request',
    'request-reason': 'Request Reason',
    'requested-by': 'Requested by',
    'request-type': 'Request Type',
    'the-request-is-accepted': 'The request is accepted',
    'the-request-is-reject': 'The request is reject',
    'disable-customer': 'Deactivate a customer',
    'are-you-sure-you-want-to-deactivate-this-client': 'Are you sure you want to deactivate this client',
    'delete-customer': 'Delete a customer',
    'deactivate-customer': 'Deactivate a customer',
    'modification': 'Modification',
    'creation': 'Creation',
    'deletion': 'Deletion'
}